import { EnglishIcon } from 'components/ui-kit/icons/iconComponents/EnglishIcon'
import { FrenchIcon } from 'components/ui-kit/icons/iconComponents/FrenchIcon'
import { GermanIcon } from 'components/ui-kit/icons/iconComponents/GermanIcon'
import { PortugalIcon } from 'components/ui-kit/icons/iconComponents/PortugalIcon'
import { RussianIcon } from 'components/ui-kit/icons/iconComponents/RussianIcon'
import { SpanishIcon } from 'components/ui-kit/icons/iconComponents/SpanishIcon'

/* ==========================================================================
  LANGUAGES
  ========================================================================== */
const LANGUAGES = [
  { label: 'English', languageCode: 'en', flag: EnglishIcon },
  { label: 'German', languageCode: 'de', flag: GermanIcon },
  { label: 'Spanish', languageCode: 'es', flag: SpanishIcon },
  { label: 'French', languageCode: 'fr', flag: FrenchIcon },
  { label: 'Portuguese', languageCode: 'pt', flag: PortugalIcon },
  { label: 'Russian', languageCode: 'ru', flag: RussianIcon }
]

/* ==========================================================================
  HTTP Method Types
========================================================================== */
const METHOD_TYPES = {
  get: 'get',
  post: 'post',
  put: 'put',
  delete: 'delete',
  patch: 'patch'
}

/* ==========================================================================
  Transaction types
========================================================================== */
export const TRANSACTION_TYPES = {
  BET: 'bet',
  WIN: 'win',
  ROLLBACK: 'rollback'
}

/* ==========================================================================
LocalStorage / Cookie data
========================================================================== */
const TOKEN = 'admin_authtoken'
const LANGUAGE = 'admin_language'
const ADMIN_ID = 'admin_id'
const ROLE = 'operator_role'

/* ==========================================================================
Operator Roles
========================================================================== */
const OPERATOR_ROLES = {
  operator: 'OPERATOR',
  operatorUser: 'OPERATOR_USER'
}

/* ==========================================================================
Loader types
========================================================================== */
const LOADER_TYPE = {
  SCALE: 'scale',
  PULSE: 'pulse'
}

/* ==========================================================================
  TOASTER / NOTIFICATION Types
========================================================================== */
const TOASTER_TYPE = {
  success: 'success',
  error: 'error',
  warning: 'warning',
  info: 'info'
}

/* ==========================================================================
  Loader Types
========================================================================== */
const LOADER_HANDLER_TYPES = {
  page: 'pageLoader',
  submit: 'submitButtonLoader',
  table: 'tableLoader'
}

/* ==========================================================================
  Table Cell Type
========================================================================== */
const TABLE_CELL_TYPE = {
  status: 'status',
  switch: 'switch',
  button: 'button',
  date: 'date',
  text: 'text',
  number: 'number',
  default: 'default',
  updateIconButton: 'updateIconButton',
  deleteIconButton: 'deleteIconButton',
  actionCell: 'actionCell',
  enableDisable: 'enableDisable',
  cancelButton: 'cancelButton',
  custom: 'custom'
}

/* ==========================================================================
  All the navigation route Paths
========================================================================== */
// const gamesSectionParentRoute = '/games'
// const playersSectionParentRoute = '/players'
// const performanceSectionParentRoute = '/performance'

const ROUTE_PATHS = {
  rootPath: '/',
  login: '/login',
  changePassword: '/change-password',
  resetPassword: '/reset-password/:adminId/:token',
  settings: '/settings',
  dashboard: '/dashboard',
  dailyStatistics: '/daily-statistics',
  profile: '/profile',
  gameSettings: '/game-settings',
  editGameSettings: '/game-settings/edit',
  users: '/users',
  usersDetail: '/users/:userId/details',
  createUser: '/users/create',
  editUser: '/users/:userId/edit',
  admins: '/admins',
  createAdmin: '/admins/create',
  adminsDetail: '/admins/:adminId/details',
  editAdmin: '/admins/:adminId/edit',
  transactions: '/transactions',
  withdrawRequests: '/withdraw-requests',
  gameReports: '/game-reports/',
  staticRoundDetailsPage: '/round-details-page',
  notFound: '/not-found',
  cryptoCurrency: '/crypto-currency',
  createCryptoCurrency: '/crypto-currency/create',
  editCryptoCurrency: '/crypto-currency/edit',
  promotions: '/promotions',
  createPromotion: '/promotions/create',
  campaignDetail: '/promotions/:campaignId/details',
  freeSpinReports: '/promotions/free-spin-reports',
  pendingBets: '/pending-bets'
}

/* ==========================================================================
  DIALOG Types
========================================================================== */
const DIALOG_TYPE = {
  add: 'add',
  update: 'update',
  delete: 'delete',
  view: 'view',
  hide: ''
}

/* ==========================================================================
  Miscellaneous Constants
========================================================================== */
export const DEFAULT_PAGE_NO = 1
export const DEFAULT_CURRENCY_ID = 2
export const DEFAULT_CURRENCY_NAME = 'USD'
export const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD'

const DEFAULT_GAME_ID = {
  PLINKO: 1,
  LIMBO: 2,
  MINE: 3,
  COIN_HEIST: 4,
  HILO: 5,
  DICE: 6,
  COIN_FLIP: 7,
  KENO: 8,
  ROULETTE: 9,
  CRASH: 10
}

export const GAME_NAMES = {
  [DEFAULT_GAME_ID.PLINKO]: 'Plinko',
  [DEFAULT_GAME_ID.LIMBO]: 'Limbo',
  [DEFAULT_GAME_ID.MINE]: 'Mine',
  [DEFAULT_GAME_ID.COIN_HEIST]: 'Coin Heist',
  [DEFAULT_GAME_ID.HILO]: 'Hilo',
  [DEFAULT_GAME_ID.DICE]: 'Dice',
  [DEFAULT_GAME_ID.COIN_FLIP]: 'Coin-Flip',
  [DEFAULT_GAME_ID.KENO]: 'Keno',
  [DEFAULT_GAME_ID.ROULETTE]: 'Roulette',
  [DEFAULT_GAME_ID.CRASH]: 'Crash',
}

export const FREE_SPIN_STATUS = {
  ACTIVE: 'ACTIVE',
  EXPIRED: 'EXPIRED',
  CONSUMED: 'CONSUMED',
  REVOKED: 'REVOKED'
}

export const BET_RESULT = {
  WON: 'won',
  LOST: 'lost',
  CANCELLED: 'cancelled',
  PENDING: 'pending'
}

// Export All constant variables
export {
  TOASTER_TYPE,
  LANGUAGES,
  TOKEN,
  LANGUAGE,
  ADMIN_ID,
  ROLE,
  OPERATOR_ROLES,
  ROUTE_PATHS,
  LOADER_TYPE,
  METHOD_TYPES,
  LOADER_HANDLER_TYPES,
  TABLE_CELL_TYPE,
  DIALOG_TYPE,
  DEFAULT_GAME_ID
}
